import React, { Component } from "react";
import "./App.css";
import { Link, Redirect } from "react-router-dom";
import Axios from "axios";
import ReactTooltip from "react-tooltip";
import ClipLoader from "react-spinners/ClipLoader";
import QrReader from "react-qr-scanner";
import Footer from "./components/Footer";
import {
  IoIosContact,
  IoIosLogOut,
  IoIosRemoveCircleOutline,
  IoIosCheckmarkCircleOutline,
  IoIosAdd,
} from "react-icons/io";
import {
  BsCalendar,
  BsPeople,
  BsBoundingBoxCircles,
  BsPerson,
  BsLock,
  BsPen,
  BsCollectionFill,
  BsCollection,
} from "react-icons/bs";
import { BiEditAlt, BiMenu } from "react-icons/bi";
import { SiMinutemailer } from "react-icons/si";
import Header3 from "./components/Header3";
import { IoStar } from "react-icons/io5";
import SideNav from "./layouts/SideNav";
import EventsDashboard from "./screens/dashboard/Dashboard";
import Header from "./layouts/Header";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    const isMobile = window.innerWidth <= 768;
    this.state = {
      query: "",
      password: "",
      response: "",
      error: "",
      errorDisplay: "none",
      details: [],
      numberOfclientes: 0,
      numberOfbooster: 0,
      numberOfboosterDeactivated: 0,
      delay: 100,
      result: "No result",
      loader: true,
      isMobile,
      collapsed: isMobile,
    };

    this.handleScan = this.handleScan.bind(this);
  }

  componentDidMount() {
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile);

    const businessname = localStorage.getItem("businessname");
    const accounttype = localStorage.getItem("accounttype");
    const businessid = localStorage.getItem("businessid");
    document.title = businessname + " - Business dashboard";

    // get numberOfboosterDeactivated
    Axios.get(
      "https://karamale.com/apps/kscanner/webservices.php?query=NUMBEROFBOOSTERDEACTIVATEDS&businessid=" +
        businessid,
      {
        withCredentials: true,
      }
    ).then((response) => {
      if (response.data.val == 1) {
        this.setState({
          numberOfboosterDeactivated: response.data.boosterDeactivatedCount,
        });
      } else {
        this.setState({ numberOfboosterDeactivated: 0 });
      }
    });

    // get numberOfclientes
    Axios.get(
      "https://karamale.com/apps/kscanner/webservices.php?query=NUMBEROFCLIENTELE&businessid=" +
        businessid,
      {
        withCredentials: true,
      }
    ).then((response) => {
      if (response.data.val == 1) {
        this.setState({ numberOfclientes: response.data.clientCount });
      } else {
        this.setState({ numberOfclientes: 0 });
      }
    });

    Axios.get(
      "https://karamale.com/apps/kscanner/webservices.php?query=MYEVENTS&accountid=" +
        businessid +
        "&accounttype=" +
        accounttype +
        "&dashboard=yes",
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        this.setState({ loader: false });
        if (response.data.val == 0) {
          this.setState({ details: [] });
        } else {
          this.setState({ details: response.data });
        }
      })
      .catch((error) => console.log(error));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateIsMobile);
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768;
    this.setState((prev) => ({
      isMobile,
      collapsed: isMobile ? true : prev.collapsed, // auto-collapse only when entering mobile
    }));
  };

  details = () => {
    let activeString = "";
    const accountid = localStorage.getItem("businessid");
    const businessname = localStorage.getItem("businessname");
    const accounttype = localStorage.getItem("accounttype");
    let { event, poster, nb } = "";

    let currentDate = new Date();
    let month = "";
    let date = "";
    if (currentDate.getMonth() <= 9) {
      month = "0" + (currentDate.getMonth() + 1);
    } else {
      month = currentDate.getMonth() + 1;
    }

    if (currentDate.getDate() <= 9) {
      date = "0" + currentDate.getDate();
    } else {
      date = currentDate.getDate();
    }

    let curDate = currentDate.getFullYear() + "-" + month + "-" + date;

    let string = "";

    return (
      <div>
        <label className={this.state.loader ? "w-100 text-center" : "d-none"}>
          <ClipLoader size={20} color="#dcdcdc" />
        </label>
        {this.state.details.length < 1 ? (
          <div className={this.state.loader ? "d-none" : ""}>
            <label
              style={{
                width: "100%",
                textAlign: "center",
                fontSize: 13.5,
                color: "#5B7083",
              }}
            >
              No events found.
            </label>
          </div>
        ) : (
          <>
            {this.state.details.map((item, index) => {
              let tempEventname = item.eventname;
              const passEventname = tempEventname;
              const campaignstatus = item.campaignstatus;
              let budget = item.budget;
              let ticketset = item.ticketid;
              let markticketset = "";
              let inCheckmark = "";
              let thumbnail = item.thumbnail;
              let pausebtn = "";
              {
                item.activation == 1
                  ? (activeString = (
                      <IoIosCheckmarkCircleOutline size={18} color="green" />
                    ))
                  : (activeString = (
                      <IoIosRemoveCircleOutline size={18} color="red" />
                    ));
              }

              {
                item.eventname.length > 19
                  ? (event = item.eventname.substring(0, 19) + "...")
                  : (event = item.eventname);
              }

              if (
                item.thumbnail.trim() === "" ||
                item.thumbnail.trim() === "none"
              ) {
                poster = "https://karamale.com/apps/kscanner/placeholder.png";
                nb = (
                  <label
                    data-tip="Complete event setup"
                    className="float-right"
                    style={{ color: "red", float: "right", fontWeight: 400 }}
                  >
                    <ReactTooltip />
                    <BiEditAlt />
                  </label>
                );
              } else {
                nb = "";
                poster =
                  "https://karamale.com/apps/kscanner/posters/" +
                  item.businessid +
                  "/" +
                  item.eventid +
                  "/" +
                  item.thumbnail;
              }

              return (
                <div className={"col-lg-12 p-0"}>
                  <div className="item-select w-100 pr-1 pl-1 pb-2 pt-3">
                    <Link
                      to={{
                        pathname: "/editevent",
                        state: {
                          is_sponsorship: item.is_sponsorship,
                          campaignstatus: item.campaignstatus,
                          eventid: item.eventid,
                          eventname: item.eventname,
                          poster: poster,
                          eventdate: item.eventday,
                          enddate: item.enddate,
                          event_date: item.event_day,
                          finish_date: item.finish_day,
                          theme: item.theme,
                          venue: item.venue,
                          expectednum: item.expected,
                          time: item.time,
                          endtime: item.endtime,
                          prevpage: "dashboard",
                        },
                      }}
                      className="w-100"
                    >
                      <div className="row" style={{ display: "flex" }}>
                        <div className="col-lg-3 col-2 col-sm-2 text-center">
                          <div
                            style={{
                              backgroundImage: `url(` + poster + `)`,
                              width: 55,
                              height: 55,
                              borderRadius: 100,
                              backgroundSize: "100%",
                            }}
                          ></div>
                        </div>
                        <div
                          className="col-lg-9 col-10 col-sm-10"
                          style={{ cursor: "pointer" }}
                        >
                          <label
                            className="item-names w-100"
                            style={{
                              color: "#000",
                              fontWeight: "bold",
                              cursor: "pointer",
                            }}
                          >
                            {event} {nb} <br />
                            <label
                              style={{
                                color: "grey",
                                fontSize: 13,
                                fontWeight: "normal",
                                textTransform: "none",
                                cursor: "pointer",
                              }}
                            >
                              {item.eventday}
                            </label>
                            {item.is_sponsorship == 1 ? (
                              <label className="sponsored-badge">
                                <IoStar /> Sponsored
                              </label>
                            ) : (
                              ""
                            )}
                          </label>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              );
            })}
          </>
        )}

        {this.state.details.length < 4 ? (
          ""
        ) : (
          <div className="item-select w-100 pr-1 pl-1 pb-3 pt-3 mb-2">
            <Link
              to={{
                pathname: "/myevents",
              }}
              className="w-100"
            >
              <div className="row" style={{ display: "flex" }}>
                <div className="col-lg-3 col-2 col-sm-2 text-center">
                  <div
                    style={{
                      backgroundImage: `url(https://karamale.com/apps/kscanner/placeholder.png)`,
                      width: 55,
                      height: 55,
                      borderRadius: 100,
                      backgroundSize: "100%",
                    }}
                  ></div>
                </div>
                <div
                  className="col-lg-9 col-10 col-sm-10"
                  style={{ cursor: "pointer" }}
                >
                  <label
                    className="item-names"
                    style={{
                      color: "#000",
                      fontWeight: "bold",
                      cursor: "pointer",
                      color: "#3399cc",
                    }}
                  >
                    More... <br />
                    <label
                      style={{
                        color: "grey",
                        fontSize: 13,
                        fontWeight: "normal",
                        textTransform: "none",
                        cursor: "pointer",
                      }}
                    >
                      See all your events
                    </label>
                  </label>
                </div>
              </div>
            </Link>
          </div>
        )}
      </div>
    );
  };

  handleScan(data) {
    this.setState({
      result: data,
    });
  }
  handleError(err) {
    console.error(err);
  }

  handleToggle = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }));
  };

  render() {
    if (localStorage.getItem("businessname") === null) {
      return <Redirect to="/login" />;
      //   return exit(1);
    } else {
    }
    const businessname = localStorage.getItem("businessname");
    const businessid = localStorage.getItem("businessid");
    const accounttype = localStorage.getItem("accounttype");

    const previewStyle = {
      height: 240,
      width: 320,
      border: "thin solid red",
    };

    const { collapsed, isMobile } = this.state;

    const sidebarWidth =
      window.innerWidth > 768 ? (this.state.collapsed ? 60 : 190) : 0;
    return (
      <div className="view">
        {/* <Header3 /> */}

        <Header />
        <SideNav
          collapsed={this.state.collapsed}
          onToggle={this.handleToggle}
        />

        <div
          className="main-content"
          style={{
            marginLeft: this.state.isMobile
              ? "0px"
              : this.state.collapsed
              ? "40px"
              : "240px",
          }}
        >
          {/* ✅ Mobile overlay when sidebar is open */}
          {isMobile && !collapsed && (
            <div
              className="mobile-overlay active"
              onClick={this.handleToggle}
            />
          )}

          {this.state.isMobile && this.state.collapsed && (
            <label className="mobile-toggle" onClick={this.handleToggle}>
              <BiMenu size={25} />
            </label>
          )}
          <EventsDashboard />
        </div>
        {/* <Link
          to={{ pathname: "addevent", state: { prevpage: "dashboard" } }}
          className={"add-event"}
        >
          <label>
            <IoIosAdd size={25} />{" "}
            <label className="hide-title">Create event</label>
          </label>
        </Link> */}
        <div
          className="error-login"
          style={{ display: this.state.errorDisplay, textAlign: "center" }}
        >
          {this.state.error}
        </div>
        {/* <Footer /> */}
      </div>
    );
  }
}

export default Dashboard;
